// extracted by mini-css-extract-plugin
export var arrow = "_gn-1";
export var content = "_gn-0";
export var highlighted = "_gn-2";